import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { ErrorHandlerService, UserService } from '@app/services';

@Component({
  selector: 'app-configurations-notification',
  templateUrl: './configurations-notification.component.html',
  styleUrls: ['../configurations.scss', './configurations-notification.component.scss'],
  standalone: false
})
export class ConfigurationsNotificationComponent implements OnInit {
  notificationForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.userService.notificationsInfo().subscribe({
      next: notificationInfo => {
        this.notificationForm = this.formBuilder.group({
          notification: this.formBuilder.group({
            signature_you: !!notificationInfo.signature_you,
            signature_others: !!notificationInfo.signature_others,
            signature_approval: !!notificationInfo.signature_approval
          })
        });
      }
    });
  }

  updateNotificationsInfo() {
    this.notificationForm.markAllAsTouched();
    this.notificationForm.get('notification').disable();

    this.userService
      .updateNotificationsInfo(this.notificationForm.value)
      .pipe(finalize(() => this.notificationForm.get('notification').enable()))
      .subscribe({
        error: error => this.errorHandlerService.handle(error)
      });
  }
}
